import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { IoAlbums, IoHome, IoLocation, IoLogoBuffer, IoPower, IoShareSocial, IoVideocam } from "react-icons/io5";
import usePropertyOwner, { usePropertyRole } from "../../../hooks/usePropertyOwner";
import { SHARE_PATHS } from "../../../pages/Share/shareUtils";
import { APP_SETTINGS_PATHS } from "../../../pages/Settings/paths";
import { CAMERA_PATHS } from "../../../pages/Camera/paths";
import Sheet from "./Sheet";
import { useToggleTop } from "../../common/ToggleTop";
import CreatePlaceDialog from "../../places/CreatePlaceDialog";

// The options behind the app's "+" on Home (app/screens/AddDevice/AddDeviceModal.js),
// by the user's role in the selected property. Devices are set up over
// Bluetooth and Wi-Fi, which only the mobile app can do. Only the property's
// creator can share it; other owners and guests see its info instead.
const CREATE_PROPERTY = { name: "Create Home/Property", icon: IoHome, create: "home" };
const SHARE_PROPERTY = { name: "Share Property", icon: IoShareSocial, path: SHARE_PATHS.HOME };
const PROPERTY_INFO = { name: "Property info", icon: IoHome, path: SHARE_PATHS.HOME };
// Owners, shared owners too, keep the home's postal address.
const HOME_ADDRESS = { name: "Home Address", icon: IoLocation, path: APP_SETTINGS_PATHS.HOME_ADDRESS };
const OWNER_OPTIONS = [
  { name: "Setup Device", icon: IoPower, note: "Set up new devices with the HASHh Connect app" },
  // a camera is added on the web too: the camera list opens with its add dialog
  { name: "Add Camera", icon: IoVideocam, path: CAMERA_PATHS.LIST, state: { add: true } },
  CREATE_PROPERTY,
  { name: "Create Room", icon: IoAlbums, create: "room" },
  { name: "Create Floor", icon: IoLogoBuffer, create: "floor" },
];

const AddSheet = ({ open, onClose }) => {
  const toast = useToggleTop();
  const history = useHistory();
  const role = usePropertyRole();
  const isCreator = usePropertyOwner();
  const [creating, setCreating] = useState(null);
  let options = [CREATE_PROPERTY];
  if (role === "owner") options = [...OWNER_OPTIONS, isCreator ? SHARE_PROPERTY : PROPERTY_INFO, HOME_ADDRESS];
  else if (role === "guest") options = [PROPERTY_INFO];

  const choose = (option) => {
    if (option.create) {
      onClose();
      setCreating(option.create);
    } else if (option.path) {
      onClose();
      history.push(option.path, option.state);
    } else {
      toast(option.note ?? `${option.name} is coming to the web dashboard soon`, "blue");
    }
  };

  return (
    <>
      <Sheet open={open} onClose={onClose} title="Create" tinted>
        <div className="hx-create-grid">
          {options.map((option, index) => {
            const Icon = option.icon;
            return (
              <button
                key={option.name}
                type="button"
                className="hx-create-box"
                style={{ "--i": index }}
                onClick={() => choose(option)}
              >
                <Icon aria-hidden="true" />
                {option.name}
                {option.note || option.path || option.create ? null : <span className="hx-soon">Soon</span>}
              </button>
            );
          })}
        </div>
      </Sheet>
      <CreatePlaceDialog kind={creating ?? "home"} open={Boolean(creating)} onClose={() => setCreating(null)} />
    </>
  );
};

export default AddSheet;
